<template>
  <div class="gameTurbo-platform" v-if="show">
    <slot></slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { is_display_gameTurbo } from './index'

  export default {
    computed: {
      ...mapState(['isMobile', 'isTurbo']),
      show() {
        return is_display_gameTurbo(this.isMobile, this.isTurbo)
      },
    },
  }
</script>
